import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import * as Types from "../data-types/api-client/api-products";
import * as Contact from "../data-types/api-client/api-contacts";
import PriceListPDF from "./PriceListPDF";
import { AiOutlineDownload } from "react-icons/ai";
import { useState } from "react";

const PriceListComponent = ({
  provisionData,
  contactData,
}: {
  provisionData: Types.RentProvision | undefined;
  contactData: Contact.ContactData | undefined;
}) => {
  const [loading, setLoading] = useState(false);

  const categories = provisionData?.categories;
  const devices = provisionData?.priceList?.devices;
  const contacts = contactData;
  const priceList = provisionData?.priceList;

  const handleDownload = async () => {
    setLoading(true);
    const blob = await pdf(
      <PriceListPDF
        categories={categories}
        devices={devices}
        contacts={contacts}
        priceList={priceList}
      />,
    ).toBlob();
    saveAs(blob, "Cennik - Rentkos.pdf");
    setLoading(false);
  };

  return (
    // <button
    //   onClick={handleDownload}
    //   className="flex font-semibold rounded-lg font-exo text-lg items-center gap-2 border border-gray-300 shadow-2xl px-5 py-3 hover:bg-custom-red hover:border-custom-red hover:text-custom-white transition"
    // >
    //   <MdDownloadForOffline className="text-custom-red text-xl" />
    //   {loading ? "Načítavam..." : "Stiahnuť cenník"}
    // </button>
    //   <button
    //     onClick={handleDownload}
    //     className="
    //   group
    //   flex
    //   font-semibold
    //   text-custom-atrament
    //   rounded-lg
    //   text-lg
    //   items-center
    //   gap-2
    //   border
    //   border-gray-300
    //   shadow-2xl
    //   px-5
    //   py-3
    //   hover:bg-custom-red
    //   hover:border-custom-red
    //   hover:text-custom-white
    //   transition-all
    // "
    //   >
    //     <MdDownloadForOffline className="text-custom-red w-6 h-6 transition-colors group-hover:text-custom-white" />

    //     {loading ? "Načítavam..." : "Stiahnuť cenník"}
    //   </button>
    <button
      onClick={handleDownload}
      disabled={loading}
      className="
    group
    inline-flex
    items-center
    justify-between
    gap-4
    rounded-2xl

    bg-[#f7ebe4]

    px-8
    py-4
    text-left
    text-custom-red

    shadow-md
    border border-custom-white/30

    transition-all
    duration-200

    hover:-translate-y-0.5
    hover:shadow-lg
    hover:brightness-105

    disabled:cursor-not-allowed
    disabled:opacity-60
  "
    >
      {/* ICON */}
      <span
        className="
    flex h-12 w-12 items-center justify-center 
    rounded-xl 
    bg-custom-salmon 
    backdrop-blur-sm
  "
      >
        <AiOutlineDownload className="w-6 h-6 text-custom-white" />
      </span>

      {/* TEXT */}
      <span className="flex flex-col text-custom-blue">
        <span className="text-lg font-bold leading-tight tracking-wider">
          {loading ? "Načítavam..." : "Stiahnuť cenník"}
        </span>
        <span className="text-sm">PDF dokument</span>
      </span>

      {/* ARROW */}
      <span
        className="
    ml-auto
    text-xl
    transition-transform
    group-hover:translate-x-1
  "
      >
        →
      </span>
    </button>
  );
};

export default PriceListComponent;
